/**
 * 型ガード
 *
 * @description payload が正常な値かどうかを判定し、正の場合 action 関数から取得した payload の型を定義する
 */
export const isSucceededPayload = (payload) => !!payload;
